import { Logger } from "@lululemon/mwa-logger";
var log = new Logger({
    owner: "dao-data-enablement",
    app: "mwa-personalization"
});
export default log;
